"use client";

import { ReactNode, useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { getOptionalMe } from "@/features/auth/api";
import { useAuthPromptStore } from "@/store/useAppStore";

const protectedPrefixes = ["/admin", "/applications", "/breeder", "/favorites", "/notifications", "/orders", "/payments", "/profile", "/reviews"];

export function ProtectedRouteGate({ children }: { children: ReactNode }) {
  const pathname = usePathname();
  const protectedRoute = protectedPrefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));
  const [allowed, setAllowed] = useState(!protectedRoute);
  const openAuthPrompt = useAuthPromptStore((state) => state.openAuthPrompt);
  useEffect(() => {
    if (!protectedRoute) { setAllowed(true); return; }
    let active = true;
    setAllowed(false);
    void getOptionalMe().then((user) => {
      if (!active) return;
      setAllowed(Boolean(user));
      if (!user) openAuthPrompt(pathname, "이 기능을 이용하려면 로그인이 필요합니다.");
    }).catch(() => { if (active) openAuthPrompt(pathname, "이 기능을 이용하려면 로그인이 필요합니다."); });
    return () => { active = false; };
  }, [openAuthPrompt, pathname, protectedRoute]);
  return allowed ? children : null;
}
